import React from 'react';

function IndicatorSeparator() {
  return null;
}

export default IndicatorSeparator;
